import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Sidebar from 'components/Sidebar';
import MobileHeader from 'components/MobileHeader';
import SearchOverlay from 'components/SearchOverlay';
import Container from 'components/Container';
import { CaretLeftIcon, CheckIcon, XIcon } from '@phosphor-icons/react';
import { useQuery } from '@tanstack/react-query';
import { getModels } from 'api/models';
import LoadingOverlay from 'components/LoadingOverlay';
import Button from 'components/Button';

export default function Models() {

    const [sidebar, setSidebar] = useState(false);
    const [search, setSearch] = useState(false);
    const [searchModels, setSearchModels] = useState('');

    const { data: models, isLoading } = useQuery({
        queryKey: ['models'],
        queryFn: async () => await getModels({}),
    });

    return (
        <>
            <Sidebar
                visible={sidebar}
                setVisible={setSidebar}
            />

            <SearchOverlay
                visible={search}
                setVisible={setSearch}
            />

            <MobileHeader
                sidebar={sidebar}
                setSidebar={setSidebar}
                search={search}
                setSearch={setSearch}
            />

            <LoadingOverlay isLoading={isLoading} />

            <div className={`fixed top-0 w-full bottom-0 transition-all duration-300 ease-in-out lg:pl-[320px] ${sidebar ? 'left-[80vw]' : 'left-0'}`}>
                <Container>
                    <div className='flex gap-3 items-center pb-8 pt-20 md:pt-14'>
                        <div className='flex-1 flex items-center gap-3'>
                            <Link to="/settings" className=''>
                                <CaretLeftIcon size={26} className='hover:text-muted' />
                            </Link>
                            <p className='text-3xl'>Modelli</p>
                        </div>
                        <Button
                            component={Link}
                            to="/settings/models/create"
                        >Aggiungi modello</Button>
                    </div>

                    <div className=''>
                        <div className='w-full'>
                            <form>
                                <input
                                    type="text"
                                    placeholder='Cerca...'
                                    className='w-full border border-light text-sm rounded-sm focus:ring-0 focus:outline-none focus:border-grey placeholder:text-muted px-4 py-3 max-w-[400px] block'
                                    onChange={(e) => setSearchModels(e.target.value)}
                                />
                            </form>
                        </div>

                        <div className='border border-light rounded-sm mt-6'>
                            {models?.filter(model => {
                                return model.name?.toLowerCase().includes(searchModels.toLowerCase()) || model.model?.toLowerCase().includes(searchModels.toLowerCase());
                            }).map((model, index) => {
                                return (
                                    <Link to={`/settings/models/${model._id}`} key={index} className='border-b border-light last:border-0 hover:bg-verylight flex items-center gap-4 p-4'>
                                        <div className='flex-1'>
                                            <p className='font-semibold'>{model.name}</p>
                                            <p className='text-muted text-sm'>{model.model}</p>
                                        </div>
                                        <div className='flex-1'>
                                            <span className={`text-xs uppercase font-medium ${model.type === 'embedding' ? 'text-purple-500' : 'text-blue-500'}`}>
                                                {model.type}
                                            </span>
                                        </div>
                                        <div className='flex-1 flex gap-2 justify-end items-center'>
                                            {model?.enabled ? (
                                                <span className='flex items-center gap-1 text-lime-500 text-xs font-medium'>
                                                    <CheckIcon size={14} />
                                                    Attivo
                                                </span>
                                            ) : (
                                                <span className='flex items-center gap-1 text-red-500 text-xs font-medium'>
                                                    <XIcon size={14} />
                                                    Disattivato
                                                </span>
                                            )}
                                        </div>
                                    </Link>
                                )
                            })}
                        </div>
                    </div>
                </Container>
            </div>
        </>
    )
}
